export default __webpack_public_path__ + "static/SR China - ISO 22000 - Certificate-a013c56b6f4f2feb659b4b8e12aac285.pdf";